export const parseIdFromGaCookie = (gaCookie: string) => gaCookie.match(/\d+\.\d+$/)?.[0];
